export default {
  IMPORT_DOC: {
    TYPE: 'DOC_IMPORT',
    LINK: (id) => {
      return '/document/view/' + id + '/view'
    },
    ICON: 'fa fa-upload'
  },
  CMT_FAQ: {
    TYPE: 'FAQ_CMT',
    LINK: (id) => {
      return '/forum/' + id + '/detail'
    },
    ICON: 'fa fa-comments'
  },
  CREATE_CHECKLIST: {
    TYPE: 'CHK_STORE',
    LINK: (id) => {
      return '/checklist/' + id + '/view'
    },
    ICON: 'fa fa-file-text-o'
  },
  CHK_ITEM_STT_UPDATE: {
    TYPE: 'CHK_ITEM_STT_UPDATE',
    LINK: (id, params) => {
      return '/checklist/' + id + '/view' + params
    },
    ICON: 'fa fa-cog'
  },
  CHK_ITEM_CMT: {
    TYPE: 'CHK_ITEM_CMT',
    LINK: (id, params) => {
      return '/checklist/' + id + '/view' + params
    },
    ICON: 'fa fa-comments'
  },
  CHANGE_STATUS_CHECKLIST: {
    TYPE: 'CHANGESTATUS',
    LINK: (id, params) => {
      return '/checklist/' + id + '/view' + params
    },
    ICON: 'fa fa-file-text-o'
  },
  EXPIRE_DOC: {
    TYPE: 'DOC_EXPIRE',
    LINK: (id) => {
      return '/document/list'
    },
    ICON: 'fa fa-expeditedssl'
  },
  CHK_ITEM_CMT_FINAL: {
    TYPE: 'CHK_ITEM_CMT_FINAL',
    LINK: (id, params) => {
      return '/checklist/' + id + '/view' + params
    },
    ICON: 'fa fa-comments'
  }
}



// WEBPACK FOOTER //
// ./src/type_notification.js